var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIvValuesOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H2C0.89543 0 0 0.89543 0 2V10C0 11.1046 0.89543 12 2 12H18C19.1046 12 20 11.1046 20 10V2C20 0.89543 19.1046 0 18 0Z",
    fill: "#272C55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V10C0.5 10.8284 1.17157 11.5 2 11.5H18C18.8284 11.5 19.5 10.8284 19.5 10V2C19.5 1.17157 18.8284 0.5 18 0.5Z",
    stroke: "#272C55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4H19.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.5V11.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0.5V11.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 9H19.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2132 7.275C3.2132 7.431 3.2732 7.539 3.4412 7.539C3.6092 7.539 3.6692 7.431 3.6692 7.275V5.571C3.6692 5.409 3.5912 5.367 3.4952 5.367C3.2402 5.367 3.3332 5.709 3.0002 5.781L2.8892 5.805C2.7332 5.835 2.6732 5.865 2.6732 5.976C2.6732 6.099 2.7272 6.135 2.8262 6.135H3.2132V7.275Z",
    fill: "#AECDFC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7882 7.122C9.8272 7.008 10.0342 6.885 10.3732 6.693C10.6912 6.513 10.8742 6.357 10.8742 5.958C10.8742 5.682 10.5892 5.367 10.1092 5.367C9.6682 5.367 9.3082 5.646 9.3082 6.012C9.3082 6.162 9.4042 6.213 9.5272 6.213C9.6472 6.213 9.6862 6.156 9.7162 6.045C9.7822 5.805 9.9112 5.727 10.1032 5.727C10.2682 5.727 10.4182 5.835 10.4182 6.03C10.4182 6.273 10.2742 6.327 9.8572 6.591C9.4822 6.828 9.2932 7.065 9.2932 7.278C9.2932 7.383 9.3652 7.5 9.5392 7.5H10.6642C10.8022 7.5 10.8862 7.446 10.8862 7.311C10.8862 7.176 10.8022 7.122 10.6882 7.122H9.7882Z",
    fill: "#AECDFC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7932 7.02C15.7932 7.188 15.9702 7.539 16.5342 7.539C16.9782 7.539 17.3442 7.311 17.3442 6.837C17.3442 6.612 17.2482 6.432 17.0232 6.369C17.1912 6.279 17.2782 6.141 17.2782 5.949C17.2782 5.658 17.0862 5.367 16.5672 5.367C16.2762 5.367 15.8412 5.523 15.8412 5.889C15.8412 6.024 15.9402 6.069 16.0422 6.069C16.2792 6.069 16.1952 5.727 16.5582 5.727C16.7172 5.727 16.8582 5.811 16.8582 5.991C16.8582 6.129 16.7802 6.216 16.6302 6.225C16.4592 6.234 16.3692 6.267 16.3692 6.423C16.3692 6.561 16.5342 6.576 16.6182 6.585C16.8252 6.606 16.8882 6.711 16.8882 6.855C16.8882 7.041 16.7682 7.179 16.5432 7.179C16.1292 7.179 16.2732 6.81 16.0062 6.81C15.8832 6.81 15.7932 6.897 15.7932 7.02Z",
    fill: "#AECDFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvValuesOperationIcon);
export default __webpack_public_path__ + "static/media/IVValuesOperationIcon.be67a640487061ad39baa0958b0c13dd.svg";
export { ForwardRef as ReactComponent };